import React, { Component }  from 'react';
import '../../style.css';
import {fetchPost, fetchPostFile} from "../../static/util/fetch";
import {Card, Space, Table, Button, Modal, Input, message, PageHeader,Typography} from 'antd';
import { EditOutlined} from "@ant-design/icons";
import FileViewer from 'react-file-viewer';
const { Column } = Table;
const { TextArea } = Input;
const { Text} = Typography;
class IPGeneralSituation extends Component {
    constructor(props) {
        super(props);
        this.state={
            IPAuthorized:[],
            survey:'',
            id:0,//选中产权的id
            companyName:this.props.companyName,
            companyId:this.props.companyId,
            input_visible:false,
            delete_visible:false,
            fileStream:'',
            preview_visible:false,
            loading:false
        }
        this.hideModal = this.hideModal.bind(this);
        this.submit = this.submit.bind(this);
        this.surveyChange = this.surveyChange.bind(this);
    }
    componentDidMount() {
        this.setState(()=>({
           loading:true
        }))
        fetchPost(global.constants.getPatentAuthorized,{companyName:this.state.companyName})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            IPAuthorized:res.data,
                            loading:false
                        }))
                    }
                    else{
                        this.setState(()=>({
                            loading:false
                        }))
                        message.info(res.msg).then()
                    }
                }
            )
    }
    hideModal(){
        this.setState(()=>({
            input_visible:false,
            delete_visible:false,
            preview_visible:false,
        }))
    }
    handleEditClick(e){
        const value = e.id
        this.setState(()=>({
            input_visible:true,
            id:value
        }))
        fetchPost(global.constants.getPatentMessage,{id:value})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            survey:res.data.survey
                        }))
                    }
                    else{
                        message.info(res.msg).then()
                    }
                }
            )
    }
    surveyChange(e){
        const value = e.target.value;
        this.setState(()=>({
            survey:value
        }))
    }
    submit(){
        let params = {
            survey:this.state.survey,
            id:this.state.id,
        }
        fetchPost(global.constants.updatePatentSurvey,params)
            .then(
                res => {
                    if(res.code === 200) {
                        message.success("更新成功").then()
                        this.setState(()=>({
                            input_visible:false,
                        }))
                        fetchPost(global.constants.getPatentAuthorized,{companyName:this.state.companyName})
                            .then(
                                res => {
                                    if(res.code === 200) {
                                        this.setState(()=>({
                                            IPAuthorized:res.data,
                                        }))
                                    }
                                }
                            )
                    }
                    else{
                        message.error(res.msg).then()
                    }
                }
            )
    }
    handleExportClick(){
        fetchPost(global.constants.exportPatentSurvey,{companyId:this.state.companyId})
            .then(
                res=>{
                    if(res.code === 200) {
                        message.success("已在云端生成，请下载").then()
                    }else{
                        message.error(res.msg).then()
                    }
                }
            )
    }
    download(){
        let params = {
            companyId:this.state.companyId,
            projectId:0,
            productId:0,
            patentId:0,
            otherId:0,
            remark:'',
            url: '/create/'+this.state.companyName+'/2-4知识产权概况.doc',
            fileName: '知识产权概况.doc'
        }
        fetchPostFile(global.constants.downloadFile,params)
            .then(
                res=>{
                    res.blob().then(
                        blob=>{
                            let blobUrl = window.URL.createObjectURL(blob);
                            let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                            let filename = '2-4知识产权概况.doc';//设置文件名称
                            aElement.href = blobUrl;//设置a标签路径
                            aElement.download = filename;
                            aElement.click();
                            window.URL.revokeObjectURL(blobUrl);
                        }
                    )
                }
            )
    }
    handlePreviewClick(){
        let params={
            companyId:this.state.companyId,
            fileName:'2-4知识产权概况.doc'
        }
        fetchPost(global.constants.checkFileProcess, params)
            .then(
                res=> {
                    if (res.code === 200) {
                        let params = {
                            companyId:this.state.companyId,
                            projectId:0,
                            productId:0,
                            patentId:0,
                            otherId:0,
                            remark:'',
                            url: '/create/'+this.state.companyName+'/知识产权概况.pdf',
                            fileName: '知识产权概况.pdf'
                        }
                        fetchPostFile(global.constants.previewFile,params)
                            .then(
                                res=>{
                                    res.blob().then(
                                        blob=> {
                                            let blobUrl = window.URL.createObjectURL(blob);
                                            this.setState(()=>({
                                                fileStream:blobUrl,
                                                preview_visible:true,
                                            }))
                                        })
                                }
                            )
                    }else{
                        message.info("云端不存在该文件，请先生成！").then()
                    }
                }
            )
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        return(
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="知识产权概况"
                        extra={[
                            <Button
                                onClick={this.handleExportClick.bind(this)}>生成</Button>,
                            <Button
                                type="primary"
                                onClick={this.handlePreviewClick.bind(this)}
                            >预览</Button>,
                        ]}
                    >
                    </PageHeader>
                </div>
                <Space direction="vertical" className="content-style" >
                    <Card bordered={true} style={{border:'solid  1px #7F9DB9'}} >
                        <Table dataSource={this.state.IPAuthorized} loading={this.state.loading}>
                            <Column align="center" title={<p className="list-column-style">序号</p>} width="80" render={(text,record,index)=>`${index+1}`}/>
                            <Column align="center" title={<p className="list-column-style">知识产权名称</p>} dataIndex="patentName" key="patentName" />
                            <Column
                                align="center"
                                title={<p className="list-column-style">概况</p>}
                                key="action"
                                render={(text, record) => (
                                    <Space size="middle">
                                        <Text
                                            style={ {width: 200 }}
                                            ellipsis={{tooltip: '点击按钮查看全部' }}
                                        >
                                            {record.survey}
                                        </Text>
                                        <Button
                                            type="primary"
                                            style={{marginLeft:200}}
                                            icon={<EditOutlined />}
                                            onClick={this.handleEditClick.bind(this,record)}
                                        />
                                    </Space>
                                )}
                            />
                        </Table>
                    </Card>
                </Space>
                <Modal
                    visible={this.state.input_visible}
                    title={'知识产权概况'}
                    width={"40%"}
                    onOk={this.submit}
                    onCancel={this.hideModal}
                    destroyOnClose
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary"  onClick={this.submit}>
                            确定
                        </Button>,
                    ]}
                >
                    <TextArea
                        value={this.state.survey}
                        onChange={this.surveyChange}
                        placeholder="请在此输入该产权的概况,注意段尾标点符号"
                        autoSize={{ minRows: 6, maxRows: 10 }}
                    />
                </Modal>
                <Modal
                    visible={this.state.preview_visible}
                    title={'预览'}
                    onCancel={this.hideModal}
                    destroyOnClose
                    width={'50%'}
                    footer={[
                        <Button key="back" onClick={this.hideModal}>
                            取消
                        </Button>,
                        <Button key="back"  type="primary" onClick={this.download.bind(this)}>
                            下载
                        </Button>,
                    ]}
                >
                    <FileViewer fileType='pdf'
                                filePath={this.state.fileStream}
                                onError={this.onError}
                    />
                </Modal>
            </div>
        )
    }
}
export default IPGeneralSituation;